import React from 'react';

import axios from 'src/axios';
import { GLOBAL_CONSTANTS } from 'src/components/Constants';
import InvalidLinkPage from 'src/components/UI/addons/InvalidLinkPage';
import EmailAuthentication from './EmailAuthentication';
import FormContextProvider from './FormContext';
import CustomFormContainer from './CustomFormContainer';
import { APICONSTANTS, CONSTANTS } from './Constants';

export default function CustomFormWithAuth() {
  const [authenticated, setAuthenticated] = React.useState(false);
  // Validate the LINK before anything else. Previously a malformed/expired token
  // still showed the email prompt and only said "This link has expired!" after
  // the user typed an email — misleading for a made-up/tampered link. verify-form-link
  // runs through the token middleware (403 for a bad/expired token) and 404s for
  // a valid-signature-but-unknown token, so only a real, live link returns 200.
  const [linkState, setLinkState] = React.useState('checking'); // checking | valid | invalid

  React.useEffect(() => {
    const token = new URLSearchParams(window.location.search).get(
      GLOBAL_CONSTANTS.tokenKey
    );
    if (!token) {
      setLinkState('invalid');
      return;
    }
    axios
      .get(APICONSTANTS.verifyFormLink, {
        headers: { [CONSTANTS.authTokenKey]: token }
      })
      .then(() => setLinkState('valid'))
      .catch(() => setLinkState('invalid'));
  }, []);

  if (linkState === 'invalid') return <InvalidLinkPage />;
  if (linkState === 'checking') return null; // brief token check

  if (!authenticated) return <EmailAuthentication setAuth={setAuthenticated} />;

  return (
    <FormContextProvider>
      <CustomFormContainer />
    </FormContextProvider>
  );
}
